import React from "react";
import { cn } from "@/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import LoaderIcon from "@/assets/icons/HERO-LOADER-loader-2-svgrepo-com.svg";

const spinnerVariants = cva("", {
  variants: {
    show: {
      true: "",
      false: "hidden",
    },
  },
  defaultVariants: {
    show: true,
  },
});

const loaderVariants = cva(
  "block shrink-0 animate-spin overflow-visible text-primary",
  {
    variants: {
      size: {
        small: "size-4",
        medium: "size-6",
        large: "size-8",
      },
    },
    defaultVariants: {
      size: "small",
    },
  }
);

interface SpinnerContentProps
  extends VariantProps<typeof spinnerVariants>,
    VariantProps<typeof loaderVariants> {
  className?: string;
  children?: React.ReactNode;
}

export function Spinner({
  size,
  show,
  children,
  className,
}: SpinnerContentProps) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center leading-none",
        spinnerVariants({ show }),
        children ? "flex-col gap-2" : undefined
      )}
    >
      <LoaderIcon
        className={cn(loaderVariants({ size }), className)}
        aria-hidden="true"
      />
      {children}
    </span>
  );
}
